/**
 * noteIcon — the small glyph that represents a requirement evaluation
 * (F/U/A/D/V/X) in the review gutter. Shared so the classic and static
 * renderers (and any future surface) show identical note symbols.
 */
import React from "react";
import { Check, Clear, HelpOutline } from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import NAIcon from "../../../../app/customIcons/NAIcon";

export function noteIcon(note?: string): React.ReactNode {
    switch (note) {
        case "F": return <Check fontSize="small" color="success" />;
        case "U": return <Clear fontSize="small" color="error" />;
        case "A": return <NAIcon />;
        case "D": return <HelpOutline fontSize="small" color="warning" />;
        case "V": return <PriorityHighIcon fontSize="small" color="success" />;
        case "X": return <SubjectOutlinedIcon fontSize="small" sx={{ color: "info.dark" }} />;
        default: return null;
    }
}
